<template>
    <div id="detalle">
        <div class="banner">
            <h2>PERA</h2>
        </div>
        <!-- <div class="flotante">
            <img src="@/assets/images/canasta.png" alt="">
        </div> -->
        <div class="inf">
            <div class="btns">
                <div id="btn1" class="btn active" @click="cambio('origen')">ORIGEN</div>
                <div id="btn2" class="btn" @click="cambio('variedades')">VARIEDADES</div>
                <div id="btn3" class="btn" @click="cambio('dis')">DISPONIBILIDAD</div>
                <div id="btn4" class="btn" @click="cambio('prop')">BENEFICIOS</div>
                <div id="btn5" class="btn" @click="cambio('info')">INFORMACION NUTRIMENTAL</div>
            </div>
            <div id="bloques">
                <div id="origen">
                    <h2>Pera (Pirus communis)</h2>
                    <p>
                      Conocida desde tiempo inmemorial, la pera tuvo su origen en el oeste asiático y fue cultivada por egipcios,
                      griegos y romanos. Hay restos arqueológicos del tercer milenio a. C que así lo atestiguan. En China,
                      la pera –lo mismo que el peral– es un símbolo de longevidad, a la vez que la sutilidad de sus flores sugiere la fragilidad.
                    </p>
                </div>
                <div id="variedades">
                    <h2>Principales variedades</h2>
                    <ul>
                        <li>Bartlett /Red Bartlett</li>
                        <li>D´Anjou / Red D´anjou</li>
                        <li>Bosc</li>
                    </ul>
                </div>
                <div id="disponibilidad">
                    <img src="@/assets/images/Pera-temporada.jpg" alt="">
                </div>
                <div id="propiedades">
                    <p>
                      Existen numerosas variedades, con sabores y colores diferentes.
                      La pera es refrescante y nutritiva, aporta minerales y oligoelementos (cobre, magnesio, manganeso, yodo y sobre todo potasio),
                      vitaminas y enzimas.
                    </p>
                    <p>
                        La pera es un alimento muy rico en agua (más del 85%), por lo que es poco energético, ya que, 100 g proporcionan tan sólo 61 Kcal.
                    </p>
                    <p>
                      Destaca por su aporte en carbohidratos, casi un 12%, los cuales se encuentran en forma de azúcares sencillos.
                    </p>
                    <p>
                      Su gran aporte en fibra la sitúa entre los más altos del resto de las frutas.
                    </p>
                    <p>
                      La pera es rica en vitamina C, vitaminas del complejo B (tiamina, riboflavina, niacina y ácido fólico),
                      contiene algo de vitamina A y pequeñas cantidades de vitamina E y K.
                    </p>
                    <p>
                      También posee minerales, como sodio, calcio, magnesio, manganeso, hierro, cobre, fósforo, azufre, cloro, yodo y sobre todo potasio.
                    </p>
                    <p>
                      A su vez son muy ricas en ácido fólico, cobre, fósforo, potasio, boro, calcio, hierro, magnesio, sodio y azufre.
                    </p>
                </div>
                <div id="info-nut">
                  <img src="@/assets/images/tablaPera.jpg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    cambio(active) {
      const btn1 = document.getElementById('btn1');


      const btn2 = document.getElementById('btn2');


      const btn3 = document.getElementById('btn3');


      const btn4 = document.getElementById('btn4');


      const btn5 = document.getElementById('btn5');


      const origen = document.getElementById('origen');


      const variedades = document.getElementById('variedades');


      const disponibilidad = document.getElementById('disponibilidad');


      const propiedades = document.getElementById('propiedades');


      const inf = document.getElementById('info-nut');


      origen.style.display = 'none';
      variedades.style.display = 'none';
      disponibilidad.style.display = 'none';
      propiedades.style.display = 'none';
      inf.style.display = 'none';

      btn1.className = 'btn';
      btn2.className = 'btn';
      btn3.className = 'btn';
      btn4.className = 'btn';
      btn5.className = 'btn';

      if (active == 'origen') {
        console.log('origen');
        btn1.classList.add('active');
        origen.style.display = 'block';
      } else if (active == 'variedades') {
        console.log('var');
        btn2.classList.add('active');
        variedades.style.display = 'block';
      } else if (active == 'dis') {
        console.log('dis');
        btn3.classList.add('active');
        disponibilidad.style.display = 'block';
      } else if (active == 'prop') {
        console.log('props');
        btn4.classList.add('active');
        propiedades.style.display = 'block';
      } else {
        console.log('info');
        btn5.classList.add('active');
        inf.style.display = 'block';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#detalle {
  .active {
    background: gray !important;
    display: block;
  }
  .banner {
      height: 50vh;
      background-image: url('../../assets/images/grid/pera3-min.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      h2 {
          position: relative;
          top: 10%;
          color: #fff;
          font-size: 2.2em;
          font-weight: bold;
      }
  }
  .flotante {
      position: relative;
      top: -30vh;;
      z-index: 10;

  }
  .inf {
      // position: relative;
      // top: -30vh;
      .btns {
          margin: 2% auto;
          margin-bottom: 4%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .btn {
            cursor: pointer;
              width: 200px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 5px 15px;
              color: #fff;
              background-color: green;
              border-radius: 10px;
              padding: 10px 30px;
          }
          .btn:nth-child(5) {
              width: 300px;
          }
      }
      #bloques {
          text-align: justify;

        > div {
            color: gray;
           font-size: 1.3em;
            margin: 0 20%;
            h2 {
              text-align: center;
            }
        }
        #origen {
          display: block;

          h2 {
            text-align: center;
          }
        }
        #variedades {
            display: none;
        }
        #disponibilidad {
            display: none;
        }
        #propiedades {
            display: none;
        }
        #info-nut {
            display: none;
        }
      }
  }
}
</style>
